import { Directive, input } from '@angular/core';
import type { FormControl } from '@angular/forms';

@Directive({})
export abstract class AbstractFilterComponent<CONTROL_VALUE> {
  readonly label = input.required<string>();
  readonly control = input.required<FormControl<CONTROL_VALUE>>();
}
